<template>
<modal title="Rename Environment">
  <div class="columns">
    <div class="column">
      <text-input 
        required
        v-model="name"
        :error="$root.errorBag.name">Name</text-input>
    </div>
  </div>

  <template #footer>
    <action-button 
      :working="working" 
      left-icon="save" 
      @click="saveName">
      Save
    </action-button>
  </template>
</modal>  
</template>
<script>
import { updateName } from '@/api/environment'

export default {
  props: {
    envName: {
      type: String,
      default: ''
    },
    envId: {
      type: Number
    }
  },

  data: () => ({
    name: '',
    working: false
  }),

  created() {
    this.name = this.envName
  },

  methods: {
    saveName() {
      this.working = true
      updateName({
        envId: this.envId,
        name: this.name
      }, () => {
        this.working = false
        this.$close({
          name: this.name,
          envId: this.envId
        })
      }, error => {
        this.working = false
      })
    }
  }
}
</script>